export class CommonConstants {

    public static FINANCE_AUDITOR_ROLE_ID:number = 6;
    public static SUPER_ADMIN_ROLE_ID:number = 1;
    public static FINANCE_EXEC_ROLE_ID:number = 2;
    public static IT_READ_ONLY_ROLE_ID:number = 7;
    public static POST_PRODUCTION_ADMIN:number = 5;
    public static FINANCE_COORDINATOR_ROLE_ID = 3;
    public static PRODUCTION_ADMIN_COORDINATOR_ROLE_ID:number = 4;
    public static PRODUCTION_ADMIN_COORDINATOR_ROLE_READ_ONLY_ID:number = 8;
    public static POST_PRODUCTION_ADMIN_ROLE_READ_ONLY_ID:number = 9;

    // Permission IDs — DB-backed numeric values (replaces spoofable permissionName string checks) — Generated by Copilot
    public static PERMISSION_ID_NO_ACCESS:  number = 155;
    public static PERMISSION_ID_READ_ONLY:  number = 37;
    public static PERMISSION_ID_READ_WRITE: number = 38;

}